/**
 * values for setting the 'allow' in 'upload' fields
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const UPLOAD_FIELD_TYPE = {
  IMAGE:     'image',
  VIDEO_URL: 'videoUrl',
  VIDEO:     'video', //native video
};

const imageUploadItem = {
  label:            locale('Image Upload'),
  value:            UPLOAD_FIELD_TYPE.IMAGE,
  description:      'The supported image formats are .‌jpg‌; .jpeg; .‌png‌; .gif',
  tooltipIsCompact: false,
  errorMsg:         'There is a problem with the size or format of your photo.',
};

const videoUrlItem = {
  label:       locale('Video URL'),
  value:       UPLOAD_FIELD_TYPE.VIDEO_URL,
  description: 'The supported video formats are Youtube URL and Vimeo URL.',
  errorMsg:    'Please enter a supported video URL.',
};

const videoItem = {
  label:       locale('Video'),
  value:       UPLOAD_FIELD_TYPE.VIDEO,
  description: 'The supported video formats are .mp4; .m4v; .webm; .mkv; .mov',
  errorMsg:    'There is a problem with the size or format of your video.',
};

const UPLOAD_FIELD_TYPE_ALL = _.values(UPLOAD_FIELD_TYPE, 'value');

const UPLOAD_FIELD_TYPE_LIST_COMPACT = [imageUploadItem, videoUrlItem];

const UPLOAD_FIELD_TYPE_LIST_NATIVE_VIDEO = [imageUploadItem, videoUrlItem, videoItem];

export {
  UPLOAD_FIELD_TYPE,
  UPLOAD_FIELD_TYPE_LIST_COMPACT,
  UPLOAD_FIELD_TYPE_LIST_NATIVE_VIDEO,
  UPLOAD_FIELD_TYPE_ALL,
};

export default UPLOAD_FIELD_TYPE;
